import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

export const CostPerPostField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const currency = watch(MarketplaceFormKeys.currency);

  return (
    <TextField
      placeholder="400"
      rightSection={t(currency)}
      help={t('Tooltip.Cost Post Help')}
      title={t('TextForm.Cost per Posting')}
      name={MarketplaceFormKeys.costPerPost}
      {...props}
    />
  );
};
